import { engagementAppGroupIdStructuralTemplateCanvasTemplatesData } from "../engagementAppGroupIdStructuralTemplateCanvasTemplatesData";
import { engagementCanvasTemplatePreview } from "../engagementCanvasTemplatePreview";
import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateCacheKeys: AllRouteEndpoints[] =
  [engagementAppGroupIdStructuralTemplateCanvasTemplatesData, engagementCanvasTemplatePreview];
